// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\QrCodeScanResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type QrCodeScanApiResponse = {
	id: number;
	time: string;
	code: string;
	bookingId: string;
	pax: number | null;
};

export type QrCodeScan = {
	id: number;
	time: DateTime;
	code: string;
	bookingId: string;
	pax: number | null;
};

export function hydrateQrCodeScan(data: QrCodeScanApiResponse): QrCodeScan {
	return {
		...data,
		time: DateTimefromISO(data.time)!,
	};
}